<template>
	<div class="aboutBox">
		<div class="posi-r one">
			<div class="about_box posi-r overflow">
				<div class="about_title overflow">
					<p class="text-c font-size-1">McCartoon Mall</p>
					<p class="text-c font-size-2">{{contactUs.title}}</p>
					<p class="font-size-3 font-size-color lineFont">{{contactUs.descContent}}</p>
				</div>
				<div class="about_anner overflow posi-r">
					<div class="anner-box pull-l width-left">
						<div class="anner-b">
							<div class="img-boxs overflow" id="img-boxs-BBCAEC">
								<v-lazy-image :src="$axios.defaults.baseURL+contactUs.coverPic"
									:src-placeholder="require('@/assets/img/loading1.png')" class="annerImg"/>
							</div>
						</div>
					</div>
					<div class="anner-box pull-r overflow width-right">
						<div class="wh-100">
							<div class="title-r overflow" v-html="contactUs.titleIntro">
															</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	import styleysOne from '../../components/style.vue'
	import styleTwo from '../../components/styleTwo.vue'
	import VLazyImage from "v-lazy-image/v2";
	export default {
		name: '',
		components: {
			styleysOne,
			styleTwo,
			VLazyImage
		},
		data() {
            return{
				contactUs:{
					coverPic:"",
					titleIntro:"",
					title:"",
					descContent:""
				},
				loadingOne:false,
			}
		},
		created() {
			this.getIndex();
		},
		methods: {
			getIndex() {
				this.loadingOne = true;
				this.$axios.get('/index/getIndexContent?type=5')
					.then((res) => {
						this.loadingOne = false;
						if (res.status === 200 && res.data.code === 200) {
							if(res.data.data.length>0){
								this.contactUs = {
									coverPic:JSON.parse(res.data.data[0].coverPic).path,
									title:res.data.data[0].title,
									titleIntro:res.data.data[0].titleIntro,
									descContent:res.data.data[0].descContent,
								}
							}
							
							return;
						}
						this.$message.error(res.data.msg || '获取商城信息失败，请重新请求!');
					})
					.catch((error) => {
						this.loadingOne = false;
						this.$message.error('获取商城信息异常，请重新请求!');
					});
			}
		},
	};
</script>

<style scoped>
	.year{
		color:#3662C7;
		font-size:16rem;
		margin-top:80rem;
		margin-left:12rem
	}
	.name{
		font-size:16rem;
		margin-left:12rem
	}
	.book{
		width:130rem;
		height:234rem;
		position: absolute;
		top: -65rem;
		right: 10rem;
		left:10rem;
		z-index:15;
		
	}
	
	.custom-list {
		width:90%;
		margin-top:140rem;
	}
	.sro-box{
		
	}
	.liboxlist{
		margin-left:50rem;
	}
	.bottom-box{
		height:134rem;
		background: #fff;
		position: absolute;
		bottom: 0;
		right: 0;
		left:0;
		z-index:10;
		border-bottom-left-radius: 30rem;
		border-bottom-right-radius: 30rem;
		box-shadow: 0rem 6rem 12rem rgba(0, 0, 0, 0.03),
		
	}
	.title-r,
	.wh-100,
	.custom-box {
		width: 100%;
		height: 100%;
	}

	.button_about {
		width: 150rem;
		height: 45rem;
		line-height: 45rem;
		position: absolute;
		bottom: 0;
		right: 30rem;
		color: #fff;
		font-size: 16rem;
		background: #3662C7;
		border-radius: 50rem;
	}

	.about_anner {
		padding-top: 50rem
	}

	.wh-100 {
		position: relative;
		padding-top: 60rem;
		height: calc(100% - 105rem) !important;
		padding-bottom: 60rem;
	}

	
</style>